// web/src/utils/categoryIcons.js
// Category name -> Tabler icon class, used as a fallback for menu tiles
// with no image_url set. Keys match the demo menu's category names —
// adapt/extend as real venues add their own categories.

export const CATEGORY_ICONS = {
  'Beers': 'ti-beer',
  'Spirits & Wines': 'ti-glass-cocktail',
  'Grills & Nyama Choma': 'ti-meat',
  'Main Courses': 'ti-soup',
  'Starters': 'ti-salad',
  'Soft Drinks & Water': 'ti-bottle',
};

export const DEFAULT_ICON = 'ti-tools-kitchen-2';

export function iconForCategory(categoryName) {
  return CATEGORY_ICONS[categoryName] || DEFAULT_ICON;
}
